import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';
import { getObjectPropertyValue } from './util';

export class ReactFormFieldBool extends PureComponent {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
    }
    
    handleInputChange(e) {
        if(this.props.onChange)
            this.props.onChange(e.target.checked);
    }

    handleRadioChange(e) {
        if(this.props.onChange)
            this.props.onChange(e.target.value === 'true');
    }

    render() {

        let input;
        if (!this.props.choices) {
            const CheckboxView = this.props.viewProvider.getCheckboxView();
            input = (
                <CheckboxView
                    name={this.props.name}
                    value={this.props.value}
                    onChange={this.handleInputChange} 
                    isRequired={this.props.isRequired}
                    field={this.props.name}
                    isInvalid={this.props.showValidationErrors}
                />
            );
        }

        else {
            const RadioButtonView = this.props.viewProvider.getRadioButtonView();
            const { choices } = this.props;
            const trueText = getObjectPropertyValue(choices, 'trueText', this.props.lang);
            const falseText = getObjectPropertyValue(choices, 'falseText', this.props.lang);
            input = (
                <React.Fragment>
                    <div>
                        <RadioButtonView
                            name={`${this.props.name}True`}
                            value={"true"}
                            checked={this.props.value === true}
                            label={trueText}
                            onChange={this.handleRadioChange}
                            isRequired={this.props.isRequired}
                            isInvalid={this.props.showValidationErrors}
                        />
                    </div>
                    <div>
                        <RadioButtonView
                            name={`${this.props.name}False`}
                            value={"false"}
                            checked={this.props.value === false}
                            label={falseText}
                            onChange={this.handleRadioChange}
                            isRequired={this.props.isRequired}
                            isInvalid={this.props.showValidationErrors}
                        />
                    </div>
                </React.Fragment>
            );
        }

        return (
            <ReactFormGroupWrapper {...this.props}>
                {input}                 
            </ReactFormGroupWrapper>
        );
    }
}

ReactFormFieldBool.propTypes = {
    name: PT.string,
    value: PT.any,
    onChange: PT.func,
    validationErrors: PT.array,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    isRequired: PT.bool,
    choices: PT.shape({
        falseText: PT.oneOfType([PT.string, PT.shape({ fr: PT.string, en: PT.string })]),
        trueText: PT.oneOfType([PT.string, PT.shape({ fr: PT.string, en: PT.string })]),
    }),
    trueText: PT.string,
    falseText: PT.string,
    lang: PT.string
};

ReactFormFieldBool.defaultProps = {
    
};
